import { ClientType } from "@multiweb/clients/ClientType";
import { IExportImportClient } from "@multiweb/clients/exportImport";
import { IClientFactory } from "@multiweb/clients/IClientFactory";
import { DIContainer } from "../../../Global/Base/DIContainer";

export class ClassListDataSourceLightDataSource {
    private _classes: string[] = [];
    private __client: IExportImportClient | null = null;

    private get _client(): IExportImportClient {
        if (!this.__client) this.__client = DIContainer.instance.create(IClientFactory).get(ClientType.exportImport);

        return this.__client;
    }

    public async loadClassList(): Promise<string[]> {
        if (this._classes.length === 0) this._classes = await this._client.getClassNames();

        return this._classes;
    }
}
